export default __webpack_public_path__ + "static/media/CompanyProfileIllustration.4c54b553.svg";